import locales from './index.js';

/**
 * Get translation by key and lang, fallback to 'en' if missing.
 * @param {string} lang Language code (en, ja, ne, zh, ko)
 * @param {string[]} keys Translation path, e.g. ['about', 'title']
 */
export function t(lang, keys) {
  const dict = locales[lang] || locales['en'];
  let value = dict;
  for (const key of keys) {
    if (value && key in value) {
      value = value[key];
    } else {
      // fallback to English if key missing
      value = locales['en'];
      for (const k of keys) {
        value = value && value[k];
      }
      break;
    }
  }
  return value || '';
}
